<template>
  <div
    class="w-100"
    id="order-sale-by-channel-pie-chart"
  >
    <div class="card-header border-bottom">
      <h5 class="card-title">
        {{ $t(titleChart) }}
      </h5>
    </div>
    <div class="card-body h-100">
      <v-chart
        v-if="isLoaded"
        class="chart"
        :option="option"
        autoresize
      />
      <div
        class="legend-area d-flex flex-column"
        id="custom-legend"
      >
        <div
          class="d-flex align-items-center legend-item justify-content-between"
          v-for="(item, index) in customLegendVal"
          :class="[index != customLegendVal.length - 1 ? 'border-bottom' : '']"
          :key="item.id"
        >
          <div class="align-items-center d-flex">
            <div
              class="new-marker"
              :style="{ backgroundColor: item.color }"
            />
            <span 
              v-if="item.name.length > 25"
              v-tooltip:top="getTooltip(item.name)"
              :data-original-title="getTooltip(item.name)"
            >
              {{ item.name.substr(0, 25) }}...
            </span>
            <span v-else>
              {{ item.name }}
            </span>
          </div>
          <span class="ml-2">{{ $t(item.value) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { TitleComponent, TooltipComponent, LegendComponent } from "echarts/components";
import VChart, { THEME_KEY } from "@/plugins/vue-echarts";
import VueJsCounter from "@/plugins/VueJsCounter";
import { localRead } from "@/store/lang";
import moment from "moment";
import numeral from "numeral";

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent]);

export default {
  name: "ChartPieChannel",
  components: {
    VChart,
    // VueJsCounter,
  },
  provide: {
    [THEME_KEY]: "default",
  },
  props: {
    titleChart: {
      type: String,
      default() {
        return "";
      },
    },
    chartData: {
      type: Array,
      default() {
        return [];
      },
    },
    subTextChart: {
      type: String,
      default() {
        return "";
      },
    },
    isFormatNumber: {
      type: String,
      default() {
        return "";
      },
    },
    positionLabel: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    let vm = this;
    return {
      duration: 2000,
      lang: localRead("local"),
      isLoaded: false,
      option: {
        textStyle: {
          fontFamily: "Sarabun",
        },
        title: {
          text: "0",
          textStyle: {
            fontWeight: 600,
            fontSize: 15,
          },
          left: "center",
          top: "130",
          subtext: this.$t('_reportscategory.'+ vm.subTextChart),
          subtextStyle: {
            fontWeight: 500,
            fontSize: 14,
            color: "#888",
          },
        },
        tooltip: {
          padding: 0,
          textStyle: {
            fontSize: 13,
          }, 
          trigger: 'item',
          axisPointer: {
              type: "shadow",
          },
          borderColor:"#f8f9fa",
          position: vm.positionLabel,
          formatter: (params) => {
            const { data } = params
            const value = vm.isFormatNumber == 'two' ? numeral(data.value).format("0,0.00") : numeral(data.value).format("0,0");
            return `<div class="mb-1 p-0 border-0 " style="min-width:237px;height:100%">
                      <div class="bg-light border-bottom p-2">
                          <div class='d-flex align-items-center'>
                              <span style="width: 200px;word-wrap: break-word;white-space: normal;">${vm.$t(data.name)}</span>
                          </div>
                      </div>
                  
                      <div class="p-2" style="font-size:12px">
                          <div class='d-flex justify-content-between'>
                              <span>${vm.$t(vm.subTextChart)}</span>
                              <span>${value}</span>
                          </div>
                      </div>
                  </div>`;
          },
        },
        legend: {
          // show: false,
          // bottom: "15",
          // left: "center",
          // itemHeight: 10,
          // itemWidth: 10,
          // top: '5%',
          orient: 'horizontal',
          // left: 'right',
          // textAlign : 'center',
          // right: 380,
          // top: 20,
          itemWidth:15,
          itemHeight:15,
          bottom: '2%',
          itemGap:25,
          icon: "rect",
          show:false
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            }, 
            itemStyle: {
                borderColor: '#fff',
                borderWidth: 1
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
            ],
          },
        ],
        color: [
          "#03A9F4",
          "#1565C0",
          "#184E77",
          "#00337C",
          "#0081C9",
          "#03C988",
          "#5BC0F8",
          "#FFC93C",
          "#1D1CE5",
          "#4649FF",
          "#C47AFF",
          "#006C9A",
          "#00BEBE",
          "#00F3E4",
          "#9FF9C1",
        ],
      },
      hasData: false,
      customLegendVal: [],
    };
  },
  mounted() {
  },
  watch: {
    chartData() {
      this.setData();
    },
  },
  methods: {
    setData() {
      const color = [
        "#03A9F4",
        "#1565C0",
        "#184E77",
        "#00337C",
        "#0081C9",
        "#03C988",
        "#5BC0F8",
        "#FFC93C",
        "#1D1CE5",
        "#4649FF",
        "#C47AFF",
        "#006C9A",
        "#00BEBE",
        "#00F3E4",
        "#9FF9C1",
      ];
      let data = [];
      for (const [key, value] of Object.entries(this.chartData)) {
        value.color = color[key];
        data.push(value);
      }

      this.option.series[0].data = data;
      this.option.color = data.map((item) => item.color);

      let sum = 0;
      if (data && data.length) {
        sum = data.reduce((accumulator, current) => accumulator + current.value, 0);
      }
      this.option.title.text = this.isFormatNumber == 'two' ? numeral(sum).format("0,0.00") : numeral(sum).format("0,0");
      this.customLegendVal = data.map((item, index) => ({
        color: item.color,
        name: item.name,
        value: this.isFormatNumber == 'two' ? numeral(item.value).format("0,0.00") : numeral(item.value).format("0,0"),
        id: index,
      }));

      this.isLoaded = true;
    },
    getTooltip(data) {
      return data;
    },
  },
};
</script>

<style scoped>
.chart {
  height: 310px;
}
.no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.25;
  font-size: 1.5em;
  text-align: center;
}
.new-marker {
  width: 15px;
  height: 15px;
  border-radius: 1px;
  margin-right: 11px;
}
.legend-item {
  height: 36px;
}
.legend-item.border-right {
  border-right: 1px solid #e6e7f1 !important;
}
.maker-line {
  border-left: 1px solid #e6e7f1;
  height: 36px;
}
.px-15 {
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/chart/category/ChartDonut.vue